import { createApp } from 'vue'
import '@fontsource/epilogue/400.css'
import '@fontsource/epilogue/400-italic.css'
import '@fontsource/epilogue/700.css'
import '@fontsource/epilogue/700-italic.css'
import '@fontsource/sacramento/400.css'
import App from './App.vue'
import './assets/styles/main.css'

createApp(App).mount('#app')
